
import { defineComponent } from 'vue';
import BookmarkList from '@/components/BookmarkList.vue';
import MySelect from '@/components/UI/MySelect.vue';

export default defineComponent({
  name: 'home',
  components: {
    BookmarkList,
    MySelect,
  },
  computed: {
    sortOptions() {
      return this.$store.state.bookmark.sortOptions;
    },
    selectedSort: {
      get() {
        return this.$store.state.bookmark.selectedSort;
      },
      set(value) {
        this.$store.commit('bookmark/setSelectedSort', value);
      },
    },
  },

  mounted() {
    const options = {
      rootMargin: '0px',
      threshold: 1.0,
    };
    const callback = (entries: IntersectionObserverEntry[]) => {
      if (
        entries[0].isIntersecting
        && (this.$store.state.bookmark.page <= this.$store.state.bookmark.totalArticles)
        && (this.$store.state.bookmark.page < 2) // we can't use pages for free subscribe plan
      ) {
        this.$store.dispatch('bookmark/loadBookmarks'); // NEWS API call action
      }
    };
    const observer = new IntersectionObserver(callback, options);
    observer.observe(this.$refs.observer as HTMLDivElement);
  },
});
